<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Audit Data Loading...
  </div>

  <div v-else class="animated fadeIn">
    <basic-heading title="Audit Trail" class="mb-3">
      <template #right-content>
        <header-button-group :button_config="button_config">
        </header-button-group>
      </template>
    </basic-heading>

    <permission-alert-gate :permissions="'read instrument'">
      <template #gated-content>
        <instrument-card :instrument="instrument" />

        <div>
          <h3>
            Change Log
            <b-button class="float-right" variant="success" :to="`/instrument/${instrument_id}/audit-trail-history`">
              View History
            </b-button>
          </h3>
        </div>
        <AuditChangeLogTable
          :model="instrument"
        />

        <h3>Relations</h3>
        <AuditRelationTable
          :model="instrument"
        />
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import ToastNotifications from '@/components/shared/mixins/ToastNotifications'
import PermissionAlertGate from "@/components/permission/PermissionAlertGate"
import InstrumentCard from '@/components/lab/instrument/InstrumentCard'
import AuditChangeLogTable from '@/components/shared/audit/AuditChangeLogTable'
import AuditRelationTable from '@/components/shared/audit/AuditRelationTable'
import BasicHeading from '@/components/shared/BasicHeading'
import HeaderButtonGroup from '@/components/shared/headerbuttons/HeaderButtonGroup'
import InstrumentModel from '@/models/lab/InstrumentModel'

export default {
  name: "InstrumentAuditTrail",
  components: {
    PermissionAlertGate,
    InstrumentCard,
    AuditChangeLogTable,
    AuditRelationTable,
    BasicHeading,
    HeaderButtonGroup
  },
  mixins: [ToastNotifications],
  data () {
    return {
      loading: true,
      instrument: null,
      instrument_id: this.$route.params.instrument_id || null
    };
  },
  computed: {
    button_config() {
      return {
        buttons: [
          {
            icon: "fa-eye",
            linkto: `/instrument/${this.instrument_id}`,
            title: "View instrument",
            variant: "info",
          }
        ]
      }
    },
  },
  async created () {
    this.loading = true

    this.instrument = new InstrumentModel({ id: this.instrument_id })

    const params = {}
    params.connection = ['auditCreatedBy', 'auditUpdatedBy']

    this.instrument.fetch({ params }).then(() => {
      this.loading = false
    })
  },
}
</script>
